/**
 * Shared constants for the Logic Apps Automation landing page.
 *
 * Links policy
 * ────────────
 * Anything `undefined` here is intentionally unset and rendered as a
 * non-interactive (or hidden) entry in the UI until we register the
 * permanent target. The PR description tracks the canonical list of
 * pending links so design and content folks can wire them up later.
 */

export const MOBILE_BREAKPOINT = '768px';

/** Production portal URL marketing copy points users at. */
export const PROD_PORTAL_URL = 'https://auto.azure.com';

export const EXTERNAL_LINKS = {
  /** Production portal — used by hero, final CTA, "auto.azure.com" code text. */
  auto: PROD_PORTAL_URL,
  docs: undefined, // TODO: register aka.ms/auto-docs
  blog: undefined, // TODO: register aka.ms/auto-blog
  changelog: undefined, // TODO: register aka.ms/auto-changelog
  pricing: undefined, // TODO: marketing pricing page
  demo: undefined, // TODO: 2-minute product demo video
  talkToTeam: undefined, // TODO: contact-sales / talk-to-team form
  templates: undefined, // TODO: templates gallery
  apiReference: undefined, // TODO: data-plane API reference
  sdk: undefined, // TODO: SDK landing
  mcpGuide: undefined, // TODO: MCP guide
  about: undefined, // TODO: company / about page
  caseStudies: undefined, // TODO: customer case studies
  careers: undefined, // TODO: careers page
  press: undefined, // TODO: press page
  security: undefined, // TODO: security overview
  trustCenter: undefined, // TODO: trust center
  privacy: 'https://go.microsoft.com/fwlink/?LinkId=521839',
  terms: 'https://go.microsoft.com/fwlink/?LinkID=206977',
} as const;
